export enum TabAnchor {
  ALL = '',
  PRODUCTS = '#products',
  CATEGORIES = '#categories',
  TESTS = '#tests-and-guides',
  BRANDS = '#brands',
  STORES = '#stores',
}

export type TabCounts = {
  brandsCount: number;
  categoriesCount: number;
  productsCount: number;
  storesCount: number;
  testsAndGuidesCount: number;
};
